// removed by extract-text-webpack-plugin
module.exports = {"Methods":"src-components-contact----methods-module---Methods---3gt6U","Methods__method":"src-components-contact----methods-module---Methods__method---1fd_E","Methods__icon":"src-components-contact----methods-module---Methods__icon---l_CNn","Methods__text":"src-components-contact----methods-module---Methods__text---19c9s","spinAround":"src-components-contact----methods-module---spinAround---2farZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/contact/methods.module.scss
// module id = 108
// module chunks = 35783957827783 114276838955818 184470312924441